import { Box, Button, Grid, Stack, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import metro from '../../../assets/images/metro.png';
import scatter from '../../../assets/images/scatter.jpg';
import { allFeelings } from '../../../feeling';
import BatteryResult from '../../../components/views/BatteryResult';
import { faCoins } from '@fortawesome/free-solid-svg-icons';
import { faSmile } from '@fortawesome/free-solid-svg-icons';
import { faRunning } from '@fortawesome/free-solid-svg-icons';
import { faBrain } from '@fortawesome/free-solid-svg-icons';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { faHandshakeSimple } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import Tooltip from './Tooltip';
export default function Result({ data, setOpen, setShowDetail, ...props }) {
  /*eslint-disable */
  // const data = {
  //   member_id: '2107',
  //   project_id: '1669',
  //   score: 50,
  //   feeling: 'Worried',
  //   ydata: ['65', '75', '35', '65', '25', '15'],
  //   xdata: ['60', '51', '25', '35', '75', '85'],
  //   performance_challenges: [
  //     'I question my abilities',
  //     'I question my abilities',
  //     'I question my abilities',
  //   ],
  //   wellbeing_challenges: [
  //     'I cannot focus',
  //     'I question my abilities',
  //     'I question my abilities',
  //     'I question my abilities',
  //   ],
  //   companyLogo: null,
  //   companyCovered: [],
  //   requestedInitiatives: [
  //     'Retail Discounts and Savings',
  //     'Retirement',
  //     'Wealth Management',
  //   ],
  //   project: {
  //     project_id: '1669',
  //     company_id: '2502',
  //     manager_id: '2521',
  //     department_code: null,
  //     project_name: 'Baseline Survey',
  //     survey_level: 'company',
  //     survey_seq: null,
  //     parent_project_id: null,
  //     survey_start_date: '2023-07-05',
  //     survey_end_date: '2023-07-20',
  //     report_date: '2023-07-21',
  //     expected_respondents: '0',
  //     referred_by: '',
  //     layer_id: null,
  //     project_description: null,
  //     report_types: null,
  //     languages: null,
  //     bp_report_type: null,
  //     project_type: 'pulse',
  //     project_for: 'wellbeing',
  //     question_type: null,
  //     member_type: 'anonymous',
  //     owner_mode: 'organization',
  //     recruitment_role: null,
  //     last_reminder_date: null,
  //     country_code: '0',
  //     location_code: null,
  //     def_lang_code: '0',
  //     variance: '10.00',
  //     link_mode: 'single',
  //     accept_personal_info: '0',
  //     accept_country: '0',
  //     accept_location: '0',
  //     accept_division: '0',
  //     display_landing_page: '0',
  //     headsup_sent: '0',
  //     links_sent: '0',
  //     survey_invite_letter: null,
  //     survey_reminder_letter: null,
  //     thankyou_letter: null,
  //     bo_invite_letter: null,
  //     bo_reminder_letter: null,
  //     bo_comparison_letter: null,
  //     questions: null,
  //     pulse_type: 'pulse',
  //     pulsekey: null,
  //     open_comments_scores: null,
  //     survey_page_text2: null,
  //     admin_member_id: '0',
  //     administrator: null,
  //     administrator_username: null,
  //     administrator_email: null,
  //     report_group: 'division',
  //     sentiments: null,
  //     accept_q6: '1',
  //     survey_page_bgcolor: null,
  //     survey_page_font: null,
  //     survey_page_font_color: null,
  //     survey_page_font_size: null,
  //     comment_type: 'no',
  //     comment_types_heads: null,
  //     display_report: '1',
  //     company_for_logo: null,
  //     company_for_name: null,
  //     print_logo: '1',
  //     generic_link: '0',
  //     personal_name_must: '1',
  //     participants_count: null,
  //     report_type: 'pulse',
  //     link_type: null,
  //     send_report: null,
  //     used_count: '6',
  //     respondent_must: '0',
  //     survey_emails: null,
  //     refer_relation: null,
  //     leader_link_required: 'N',
  //     accept_gender: '0',
  //     accept_agegroup: '0',
  //     accept_experience: '0',
  //     comment_question: null,
  //   },
  //   logo: '',
  //   resources: [],
  // };

  const [screenSize, setScreenSize] = useState('');

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 960) {
        setScreenSize('Small');
      } else if (width >= 960 && width < 1092) {
        setScreenSize('Medium');
      } else {
        setScreenSize('Large');
      }
    };
    // screenSize=="Large" ? 150 :  screenSize=="medium" ? 110 : 100
    handleResize(); // Initial check

    window.addEventListener('resize', handleResize); // Listen for resize events

    return () => {
      window.removeEventListener('resize', handleResize); // Cleanup on component unmount
    };
  }, []);
  console.log('screenSize', screenSize);
  let width =
    screenSize === 'Large' ? 150 : screenSize === 'Medium' ? 110 : 140;

  const score = data?.score;
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const calculateRotation = () => {
      const rotationAngle = (score / 100) * (410 - 150) + 140;
      setRotation(rotationAngle);
    };

    calculateRotation();
  }, [score]);
  const chartValue = data?.score * 2.4512;
  console.log(props.niddle);
  const colorData = [
    {
      value: 40, // Meaning span is 0 to 40
      color: '#663399',
    },
    {
      value: 100, // span 40 to 140
      color: '#e91e63',
    },
    {
      value: 50, // span 140 to 190
      color: '#ff9800',
    },
    {
      value: 20,
      color: '#4caf50',
    },
  ];

  const sumValues = colorData.map((cur) => cur.value).reduce((a, b) => a + b);
  const arrowData = [
    { value: chartValue },
    { value: 0 },
    { value: sumValues - chartValue },
  ];
  const pieProps = {
    startAngle: 220,
    endAngle: 0,
    cx: width / 2,
    cy: width / 2,
  };

  const pieRadius = {
    innerRadius: (width / 2) * 0.535,
    outerRadius: (width / 2) * 0.4,
  };
  const Arrow = ({ cx, cy, midAngle, outerRadius }) => {
    //eslint-disable-line react/no-multi-comp
    const RADIAN = Math.PI / 180;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const mx = cx + (outerRadius + width * 0.03) * cos;
    const my = cy + (outerRadius + width * 0.03) * sin;
    return (
      <g>
        <circle cx={cx} cy={cy} r={width * 0.05} fill="#000" stroke="none" />
        <path
          d={`M${cx},${cy}L${mx},${my}`}
          strokeWidth="4"
          stroke="#000"
          fill="none"
          strokeLinecap="round"
        />
      </g>
    );
  };
  const [clicked, setClicked] = useState(true);
  const areas = [
    'Financial',
    'Professional',
    'Physical',
    'Mental',
    'Social',
    'Societal',
  ];
  const listIcon = [
    faCoins,
    faHandshakeSimple,
    faRunning,
    faBrain,
    faSmile,
    faUsers,
  ];
  const colors = [
    '#1ECBE1',
    '#00FF6A',
    '#646E9B',
    '#F800FF',
    '#0054FF',
    '#050401',
  ];

  const coordinates = data?.ydata.map((y, index) => ({
    x: data?.xdata[index],
    y: y,
    area: areas[index],
    color: colors[index],
  }));
  console.log('coordinates', coordinates);
  const [hoveredItem, setHoveredItem] = useState(null);
  const handleHover = (index) => {
    setHoveredItem(index);
  };
  const CustomTitle = ({ name, x, y }) => {
    return (
      <div className="flex flex-col gap-2 cursor-pointer">
        <div className="flex gap-2">
          <div>Area: </div>
          <div>{name}</div>
        </div>
        <div className="flex gap-2">
          <div>Wellbeing: </div>
          <div>{x}</div>
        </div>
        <div className="flex gap-2">
          <div>Support: </div>
          <div>{y}</div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Grid container spacing={4} className="xs:w-full md:!w-4/5 xs:p-4">
        <Grid item xs={12} sm={4} lg={3} className="flex-1">
          <Box className="flex w-full justify-center text-center">
            <Typography className="uppercase !font-bold">
              EMPLOYEE INDEX
            </Typography>
          </Box>

          <Box className="!flex flex-1 flex-col relative items-center w-full md:self-center lg:w-full  justify-center text-center">
            <img src={metro} className="xs:w-3/4 sm:w-full md:w-full" alt="" />
            <div className="radarcont absolute">
              {/* <PieChart width={width} height={width / 2 + 30}>
                <Pie
                  stroke="none"
                  activeIndex={1}
                  activeShape={Arrow}
                  data={arrowData}
                  outerRadius={pieRadius.innerRadius}
                  fill="none"
                  {...pieProps}
                  style={{
                    transition: 'all 2s ease',
                  }}
                />
              </PieChart> */}
              <div className="score-needle-container">
                <div
                  className="score-needle absolute"
                  style={{ transform: `rotate(${rotation}deg)` }}
                >
                  <div className="absolute bg-greenMain w-3 h-3 rounded-full needle-circle"></div>
                  <div className="bg-greenMain w-7 h-1 needle"></div>
                </div>
              </div>
            </div>
            <Box className="mt-1 rounded-full w-12 h-12 bg-greenMain flex justify-center items-center">
              <Typography className="text-textWhite">{data?.score}</Typography>
            </Box>
            <Box>
              <Typography className="text-greenMain font-bold">
               ( Out of 100 )
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={4} lg={3} className="flex-1">
          <Box className="flex w-full justify-center text-center">
            <Typography className="uppercase !font-bold">
              feeling about work
            </Typography>
          </Box>

          <Box className="sm:scale-100 md:scale-75 lg:scale-100 mt-12">
            <BatteryResult
              clicked={clicked}
              setClicked={setClicked}
              allFeelings={allFeelings}
              feeling={data?.feeling}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={4} lg={3} className="flex-1">
          <Box className="flex w-full justify-center text-center">
            <Typography className="uppercase !font-bold">
              Life challenges
            </Typography>
          </Box>

          <Box className="!flex flex-1 relative items-center w-full lg:w-full md:self-center justify-center text-center">
            <div
              className="xs:w-3/4 sm:w-full  md:w-full"
              style={{
                display: 'flex',
                justifyContent: 'center',
                position: 'relative',
                alignSelf: 'center',
              }}
            >
              <p
                style={{
                  fontSize: '15px',
                  fontWeight: '600',
                  position: 'absolute',
                  bottom: '-60px',
                  left: '0',
                  right: '0',
                }}
                className="scatter-text"
              >
                Self Reported Wellbeing
              </p>
              <p
                style={{
                  fontSize: '15px',
                  fontWeight: '600',
                  position: 'absolute',
                  left: '-25px',
                  bottom: '0',
                  top: '0',
                  margin: 'auto',
                }}
                className="vertical-text scatter-text"
              >
                Perceived Support
              </p>
              <img src={scatter} alt="" />
              {coordinates?.length && (
                <div className="absolute scatter-container">
                  {coordinates?.map((x, y, i) => (
                    <Tooltip
                      title={<CustomTitle name={x?.area} x={x?.x} y={x?.y} />}
                    >
                      <div
                        onMouseEnter={() => handleHover(x)}
                        onMouseLeave={() => handleHover(null)}
                        onClick={console.log('val', x, y, i)}
                        key={i}
                        style={{
                          left: `${x?.x - 2}%`,
                          bottom: `${x?.y}%`,
                          // backgroundColor: `${x.color}`,
                        }}
                        className={`absolute w-2 h-2 rounded-full icon-ctr`}
                      >
                        <FontAwesomeIcon
                          className="areasprofilecompany"
                          icon={listIcon[y]}
                          color="rgb(14, 14, 129)"
                          size="1x"
                        />
                      </div>
                    </Tooltip>
                  ))}
                </div>
              )}
            </div>
          </Box>
          <Button
            aria-label="ddd"
            className="signupCVbtnSign"
            size="small"
            onClick={() => setShowDetail(true)}
            variant="contained"
            fullWidth
            style={{
              backgroundColor: '2691a3',
            }}
            sx={{
              fontSize: '12px',
              marginTop: '45px',
              fontWeight: 500,
              padding: '8px 10px',
              textTransform: 'capitalize',
              backgroundColor: '#2691a3',
              '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
                backgroundColor: '#2691a3',
              },
            }}
          >
            What does the graph mean
          </Button>
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <Box className="flex-1">
            <Typography className="uppercase !font-bold">
              Top 3 performance challenges
            </Typography>
            <Stack gap={1} mt={2}>
              {data?.performance_challenges?.map((text) => (
                <Typography>{text}</Typography>
              ))}
            </Stack>
          </Box>
          <Box className="flex-1">
            <Typography className="uppercase !font-bold">
              Top 3 Wellbeing challenges
            </Typography>
            <Stack gap={1} mt={2}>
              {data?.wellbeing_challenges?.map((text) => (
                <Typography>{text}</Typography>
              ))}
            </Stack>
          </Box>
        </Grid>
      </Grid>
      {/* <Box className="flex justify-end p-8 w-full">
        <Button
          variant="contained"
          color="primary"
          className="mt-6 mb-4 w-max flex self-end"
          style={{
            backgroundColor: '#D0ECE6',
            color: '#000',
          }}
          onClick={() => setOpen(true)}
          sx={{
            fontSize: '16px',
            fontWeight: 500,
            padding: '8px 30px',
            textTransform: 'capitalize',
            color: '#000',
            backgroundColor: '#D0ECE6',
            '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
              backgroundColor: '#D0ECE6',
            },
          }}
        >
          Refer your friends
        </Button>
      </Box> */}
    </>
  );
}
